<template>
  <form class="move-transaction">
    <h4 class="title">
      {{ $t('CP.transferOperation') }}
    </h4>
    <event-list
      class="event-list"
      :events="filteredEvents"
      :currency="user.currency"
      :on-select-event="moveOperation"
      no-events-phrase="eventList.noEventsFound"
    />
    <div class="button-footer">
      <button-app
        @clicked="cancelSubmit"
        class="cancel-button"
        type="button"
        color-scheme="gray"
      >
        {{ $t('CP.cancel') }}
      </button-app>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import {
  DELETE_TRANSACTION_REQUEST, FETCH_EVENT_REQUEST,
  FETCH_EVENTS_REQUEST,
  MOVE_TRANSACTION_REQUEST,
} from '@/store/events/types';
import EventList from '../../components/EventList/EventList';
import ButtonApp from '../../components/Button/ButtonApp';

export default {
  name: 'MoveTransactionForm',
  components: { ButtonApp, EventList },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      events: (state) => state.events.events,
      currentEventId: (state) => state.operations.moveOperationInfo.current_event_id,
      currentTransaction: (state) => state.operations.moveOperationInfo.transaction_id,
      transactionParticipants: (state) => (
        state.operations.moveOperationInfo.transaction_participants
      ),
    }),
    filteredEvents() {
      if (this.events && this.events.length) {
        let filteredEvents = this.events;
        if (this.currentEventId) {
          filteredEvents = filteredEvents.filter((event) => {
            if (event.id === this.currentEventId) {
              return false;
            }
            return true;
          });
        }
        if (this.transactionParticipants && filteredEvents && filteredEvents.length) {
          filteredEvents = filteredEvents.filter((event) => {
            if (!event || !event.contacts || !event.contacts.length) return false;
            return this.transactionParticipants.every((transactionContact) => (
              !!event.contacts.find((eventContact) => eventContact.uid === transactionContact.uid)
            ));
          });
        }
        return filteredEvents;
      }
      return [];
    },
  },
  methods: {
    async moveOperation(id) {
      await this.$store.dispatch(MOVE_TRANSACTION_REQUEST, {
        event_id: id,
        operation_id: this.currentTransaction,
      });
      await this.$store.dispatch(DELETE_TRANSACTION_REQUEST, {
        id: this.currentTransaction,
      });
      this.$store.dispatch(FETCH_EVENTS_REQUEST);
      this.$store.dispatch(FETCH_EVENT_REQUEST, { id: this.$store.state.events.event.id });
      this.$bvModal.hide('move-transaction');
    },
    cancelSubmit() {
      this.$bvModal.hide('move-transaction');
    },
  },
};
</script>

<style lang="scss" scoped>
.move-transaction {
    color: var(--text-main-color);
    text-align: center;
}
.title {
  text-align: left;
}
.event-list {
  margin: 0 -20px;
  padding: 0 20px 20px;
  max-height: 50vh;
  overflow-y: auto;
  /*-ms-overflow-style: none;  !* IE and Edge *!*/
  /*scrollbar-width: none;  !* Firefox *!*/
  /*&::-webkit-scrollbar {*/
  /*  display: none; !* Chrome, Safari and Opera *!*/
  /*}*/
}
.button-footer {
  text-align: left;
}
.cancel-button {
  height: 38px;
  max-width: 160px;
}

@media screen and (max-width: $breakpoint-sm) {
  .move-transaction {
    width: 90%;
    margin: 12px auto;
  }
  .event-list {
    max-height: 70svh;
  }
}
</style>
